(() => {
  const key = 'mmc_language_choice_v1';
  const read = () => { try { const value = JSON.parse(localStorage.getItem(key)); return value && ['fr','en'].includes(value.language) && Date.now() - value.savedAt < 180 * 86400e3 ? value.language : null; } catch { return null; } };
  const save = language => { try { localStorage.setItem(key, JSON.stringify({language, savedAt:Date.now()})); } catch {} };
  const suggestion = document.querySelector('[data-mmc-language-suggestion]');
  const hide = () => { if (suggestion) suggestion.hidden = true; };
  document.querySelectorAll('[data-mmc-language]').forEach(button => button.addEventListener('click', event => {
    save(button.dataset.mmcLanguage);
    hide();
    // Unpublished English is available only inside Shopify's private preview.
    // The native localisation endpoint intentionally excludes unpublished languages.
    if (button.dataset.mmcPrivateLanguagePreview === 'true' && window.Shopify?.theme?.role === 'unpublished') {
      event.preventDefault();
      const target = new URL(window.location.href);
      if (!/^\/en(?:\/|$)/.test(target.pathname)) target.pathname = '/en' + (target.pathname === '/' ? '' : target.pathname);
      window.location.assign(target.href);
    }
  }));
  document.querySelector('[data-mmc-language-stay]')?.addEventListener('click', () => {save('fr'); hide();});
  document.querySelector('[data-mmc-language-dismiss]')?.addEventListener('click', () => {save('fr'); hide();});
  const primaryLanguage = String((navigator.languages || [navigator.language])[0] || '').toLowerCase();
  const frenchPage = document.documentElement.lang.toLowerCase().startsWith('fr');
  const isSearchAgent = /bot|crawler|spider|headless/i.test(navigator.userAgent);
  const isThemeEditor = Boolean(window.Shopify?.designMode);
  const stored = read();
  if (suggestion && frenchPage && primaryLanguage.startsWith('en') && !stored && !isSearchAgent && !isThemeEditor) {
    window.setTimeout(() => { if (suggestion.isConnected && !read()) suggestion.hidden = false; }, 1800);
  }
})();
